export const qualityControlRowsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const notificationItemStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
};
